// ag-charts-react v8.2.1
"use strict";

var _classCallCheck = require("/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgChartsReact = void 0;
var react_1 = require("react");
var PropTypes = require("prop-types");
var ag_charts_community_1 = require("ag-charts-community");
var AgChartsReact = /*#__PURE__*/function (_react_1$Component) {
  _inherits(AgChartsReact, _react_1$Component);
  function AgChartsReact(props) {
    var _this;
    _classCallCheck(this, AgChartsReact);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgChartsReact).call(this, props));
    _this.props = props;
    _this.chartRef = react_1.createRef();
    return _this;
  }
  _createClass(AgChartsReact, [{
    key: "render",
    value: function render() {
      return react_1.createElement("div", {
        style: this.createStyleForDiv(),
        ref: this.chartRef
      });
    }
  }, {
    key: "createStyleForDiv",
    value: function createStyleForDiv() {
      var _a;
      return Object.assign({
        height: "100%"
      }, (_a = this.props.containerStyle) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var options = this.applyContainerIfNotSet(this.props.options);
      var chart = ag_charts_community_1.AgChart.create(options);
      this.chart = chart;
      chart.chart.waitForUpdate().then(function () {
        var _a, _b;
        return (_b = (_a = _this2.props).onChartReady) === null || _b === void 0 ? void 0 : _b.call(_a, chart);
      });
    }
  }, {
    key: "applyContainerIfNotSet",
    value: function applyContainerIfNotSet(propsOptions) {
      if (propsOptions.container) {
        return propsOptions;
      }
      return Object.assign(Object.assign({}, propsOptions), {
        container: this.chartRef.current
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      this.processPropsChanges(this.props, nextProps);
      // we want full control of the dom, as AG Charts doesn't use React internally,
      // so for performance reasons we tell React we don't need render called after
      // property changes.
      return false;
    }
  }, {
    key: "processPropsChanges",
    value: function processPropsChanges(prevProps, nextProps) {
      if (this.chart) {
        ag_charts_community_1.AgChart.update(this.chart, this.applyContainerIfNotSet(nextProps.options));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = undefined;
      }
    }
  }]);
  return AgChartsReact;
}(react_1.Component);
exports.AgChartsReact = AgChartsReact;
AgChartsReact.propTypes = {
  options: PropTypes.object
};